import CdPlayer from "./CdPlayer";
import DiscImageDevice from "./DiscImageDevice";

export let CdPlayerModule : any = null;

let module_overrides = {
    locateFile: function(path : string) {
        const baseURL = window.location.origin + window.location.pathname.substring(0, window.location.pathname.lastIndexOf( "/" ));
        return baseURL + '/' + path;
    },
    mainScriptUrlOrBlob: "",
};

function convertIntVectorToArray(intVector : any) {
    let intArray : number[] = [];
    for(let i = 0; i < intVector.size(); i++) {
        let str = intVector.get(i);
        intArray.push(str);
    }
    intVector.delete();
    return intArray;
}

export let initCdPlayerModule = async function() {
    module_overrides.mainScriptUrlOrBlob = module_overrides.locateFile('CdPlayer.js');
    CdPlayerModule = await CdPlayer(module_overrides);
    CdPlayerModule.FS.mkdir("/work");
    CdPlayerModule.discImageDevice = new DiscImageDevice(CdPlayerModule);
};

export let cdLoadDisc = async function(discImagePath : string) {
    let trackList = await CdPlayerModule.loadDisc(discImagePath);
    return convertIntVectorToArray(trackList);
}

export let cdStartTrack = async function(trackNumber : number) {
    await CdPlayerModule.startTrack(trackNumber);
}

export let cdResume = async function () {
    CdPlayerModule.resume();
}

export let cdPause = async function () {
    CdPlayerModule.pause();
}
